/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { getStoreHost } from '@helpers/config';
import { modules } from '@config';
import Router from 'next/router';
import { getAppEnv } from '@core/helpers/env';
import Image from '@common_image';

const HeaderCheckout = ({ storeConfig }) => {
    const BackToStore = () => {
        if (modules.checkout.checkoutOnly) {
            window.location.replace(getStoreHost(getAppEnv()));
        } else {
            Router.push('/');
        }
    };

    const { logo_width = 200, logo_height = 33 } = storeConfig;

    return (
        <div id="header" className="flex flex-col justify-center items-center w-full h-44">
            <button className="border-none w-max" onClick={BackToStore} type="button">
                <div className="checkout-logo-wrapper">
                    <Image
                        width={logo_width}
                        height={logo_height}
                        src={`${storeConfig.secure_base_media_url}logo/${storeConfig.header_logo_src}`}
                        alt="logo"
                        quality={100}
                        storeConfig={storeConfig}
                    />
                </div>
            </button>
            <style global jsx>
                {`
                    .checkout-logo-wrapper {
                        width: ${logo_width}px !important;
                        height: ${logo_height}px !important;
                    }
                `}
            </style>
        </div>
    );
};

export default HeaderCheckout;
